import { MgItemCalculationDTO } from '../../dto';
import { SupplierItemCalculation } from './SupplierItemCalculation';
import { PriceRoundingBrand } from '@retail/rounding/types';

export interface MgItemCalculationProps {
  mgItemNumber: number;
  supplierItems: SupplierItemCalculation[];
}

export class MgItemCalculation {
  mgItemNumber: number;
  supplierItems: SupplierItemCalculation[];

  constructor({ mgItemNumber, supplierItems }: MgItemCalculationProps) {
    this.mgItemNumber = mgItemNumber;
    this.supplierItems = supplierItems;
  }

  static fromDTO = (
    dto: MgItemCalculationDTO,
    selectedBrand: PriceRoundingBrand
  ): MgItemCalculation =>
    new MgItemCalculation({
      mgItemNumber: dto.mgItemNumber,
      supplierItems: dto.supplierItems.map((dto) =>
        SupplierItemCalculation.fromDTO(dto, selectedBrand)
      ),
    });
}
